<template>
  <div class="mt-5 md:mt-8">
    <CommonPromo
      v-if="!isMm()"
      class="no-print order-last lg:order-none"
      icon-type="email"
      header1="FreeNewsletterShort"
      header2="FreeNewsletterShort2"
      :small="true"
      placement="full"
    />
    <NewsletterTop class="no-print container" />
    <CommonPromo
      v-if="isMm()"
      class="no-print container"
      icon-type="conversation"
      header1="Læs mindre – forstå mere"
      header2="Køb abonnement på Mandag Morgen og bliv klogere på de vigtigste dagsordner"
      cta-label="Abonnér på Mandag Morgen"
      cta="Routes.Subscription"
      disclaimer="Allerede abonnent? <a href='/login' class='underline'>Log ind her</a>"
      hide-if-logged-in
    />
    <CommonPromo
      v-else
      class="no-print container"
      icon-type="conversation"
      header1="14DaysTrial"
      header2="Ourmedia"
      cta-label="ReadMoreAndSignup"
      cta="Routes.Subscription"
      disclaimer="AllreadySubscribed"
      hide-if-logged-in
    />
    <ListJobs
      class="no-print order-13 lg:order-none"
      :count="15"
      :is-slider="true"
    />
    <AdsConceptAd
      v-if="isMm()"
      class="no-print hidden lg:block"
      id="mm-lb2"
      :full-width="true"
    />
    <AdsConceptAd
      v-else
      class="no-print hidden lg:block"
      id="altinget-lb1"
      :full-width="true"
    />
    <AdsConceptAd
      v-if="isSite('altinget_no', 'altinget_se')"
      class="lg:hidden order-last"
      id="altinget-mob1"
    />
    <LayoutStaticPageBottom class="no-print order-last lg:order-none" />
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()

const indexStore = useIndexStore()

if (!indexStore.currentPaper) {
  throw createError({ statusCode: 404 })
}

useSeoMeta({
  title: indexStore.currentPaperSlug
    ? config.public.site.meta.title.postfix.short +
      indexStore.currentPaper?.Name
    : config.public.site.meta.title.postfix.long,
})
</script>
